/* eslint-disable no-undef */
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import * as Constants from './constants';
import { CHATBOT_URL, chatbotAppId, chatbotRegion } from '../../config';
import { getCookie, cookies } from '../../utils/common/cookies';

function Chatbot({ addressBookUID, lang }) {
  const intl = useIntl();
  useEffect(() => {
    const jqueryScript = document.createElement('script');
    jqueryScript.src = Constants.Scripts.jQuery;
    jqueryScript.async = true;
    jqueryScript.id = 'jqueryScirpt';
    document.head.appendChild(jqueryScript);
    jqueryScript.onload = () => {
      const five9Script = document.createElement('script');
      five9Script.src = Constants.Scripts.five9Plugin;
      five9Script.async = true;
      five9Script.id = 'five9Script';
      document.head.appendChild(five9Script);
      five9Script.onload = () => {
        const five9Hours = JSON.parse(window.sessionStorage.getItem('five9'))?.nextSevenDaysBusinessHours;
        const timeZone = five9Hours?.[0]?.timeZone;
        const week = {
          0: 'Monday',
          1: 'Tuesday',
          2: 'Wednesday',
          3: 'Thursday',
          4: 'Friday',
          5: 'Saturday',
          6: 'Sunday',
        };
        const operationHours = five9Hours?.map((day) => (
          {
            dayOfWeek: week[day.dayOfWeek],
            start: day?.fromTime || '08:00:00',
            end: day?.toTime || '20:00:00',
          }
        ));
        const currentUrl = CHATBOT_URL;
        if (addressBookUID) {
          if (!$('#five9OpenChatButton')?.length) { // load chatbot if it is not loaded yet
            initFive9ChatPlugin('', currentUrl, lang, addressBookUID, operationHours, timeZone);
          } else if (Five9ChatGetOption('campaignName')?.indexOf(lang?.toUpperCase()) === -1) { // toggle language if props.lang is different from current chatbot language.
            toggleLanguage(lang);
          }
        }
      };
    };
  }, [addressBookUID, lang]);

  const setTranslationText = () => {
    Object.entries(Constants.translationKeys).forEach(([k, v]) => {
      if (k === 'chatStartMessage') {
        Five9ChatSetOption(k, intl.formatMessage({ id: v }), true);
      } else {
        Five9ChatSetOption(k, intl.formatMessage({ id: v }));
      }
    });
  };

  const toggleLanguage = (language) => {
    Five9ChatSetOption('campaignName', `Claims SON ${language?.toUpperCase() || 'EN'} Chat`);
    Five9ChatSetVariable('Routing.languageCode', language);
    Five9ChatSetVariable('Wysdom.language', language);
    setTranslationText();
  };

  const initFive9ChatPlugin = (question, currentUrl, language, addressBookUid, operationHours, timeZone) => {
    const path = Constants.CSSDomain;
    const chatToken = getCookie(cookies.chatToken);
    const supportId = getCookie(cookies.claimSupportId);
    let options = {
      appId: chatbotAppId, // Your application Id (provided by Five9)
      region: chatbotRegion, // Five9 Region: USA, CAN, EU, LAB
      campaignName: `Claims SON ${language?.toUpperCase() || 'EN'} Chat`, // Default Five9 VCC Campaign (passed to Wysdom and used to escalate to an agent on Wysdom failure)
      zIndex: '99999', // Set a custom zIndex when widget is opened (default: '99999')
      multipleInstances: false, // Set to true to allow more than one chat session (not refresh safe)
      addAgentName: true,
      allowAttachments: false,
      attachButtonText: 'Attach',
      attachmentPlaceHolder: 'Select a file...',
      css: path.concat('MyLiveChat.css'),
      title: 'Economical',
      subtitle: intl.formatMessage({ id: 'chatbot.message.us' }),
      senderPlaceHolder: intl.formatMessage({ id: 'chatbot.placeholder' }),
      titleAvatar: '',
      profileAvatar: '',
      showEndButton: true,
      showCloseButton: false,
      fullScreenMode: false,
      maxWidth: 400,
      maxHeight: 800,
      autofocus: true,
      showTimeStamp: true,
      animation: false,
      launcherOpenLabel: intl.formatMessage({ id: 'chatbot.open.label' }),
      launcherOpenText: intl.formatMessage({ id: 'chatbot.open.text' }),
      launcherCloseLabel: intl.formatMessage({ id: 'chatbot.close.label' }),
      endButtonText: intl.formatMessage({ id: 'chatbot.end.button.text' }),
      sendButtonAlt: 'Send',

      openButtonImageCSS: Constants.Styles.openButtonImageCSS,
      closeButtonImageCSS: Constants.Styles.closeButtonImageCSS,
      openButtonCSS: Constants.Styles.openButtonCSS,
      closeButtonCSS: Constants.Styles.closeButtonCSS,
      mobileOpenButtonCSS: Constants.Styles.mobileOpenButtonCSS,
      mobileCloseButtonCSS: Constants.Styles.mobileCloseButtonCSS,
      launcherOpenTextCSS: Constants.Styles.launcherOpenTextCSS,

      launcherButton: Constants.Icons.launcherButton,
      closeButton: Constants.Icons.closeButton,
      minimizeButton: Constants.Icons.minimizeButton,
      chatStartImage: Constants.Icons.chatStartImage,
      chatStartMessage: intl.formatMessage({ id: 'chatbot.chat.start.message' }),
      chatEndMessage: intl.formatMessage({ id: 'chatbot.chat.end.message' }),
      mobile: false,
      showMenuButton: false,

      attributes: [
        { 'Chat.ContentUrl': currentUrl },
        { 'Wysdom.authenticated': 'authenticated' },
        { 'Wysdom.lineOfBusiness': 'Sonnet' },
        {
          'Wysdom.hourOfOperation': {
            timeZone,
            operationHours,
          },
        },
        {
          'Wysdom.language': language,
        },
        { 'Routing.languageCode': language },
        { 'Chat.SecureChatToken': chatToken },
        { 'Chat.SupportId': supportId },
        { 'Chat.AddressBookUID': addressBookUid },
        { Transcript: true },
      ],
      initialMessage: question,
    };

    // eslint-disable-next-line no-restricted-globals
    options = Five9ChatGetParameters(location.search, options);
    if (options.debug) {
      document.getElementById('debugAPI').style.display = 'block';
      options.callback = callback;
    }
    Five9ChatPlugin(options);
  };

  return null;
}

export default Chatbot;
